import {dashboardTabId, dashboardViews} from '../../../../../../../util/uiconstants';
import {currentResource} from '../../../../../../../util/utils';
import {DASHBOARD_VIEWS} from './constants';
import {getAvailableEntityList, getAdminAvailableEntityList, getAdminViews} from './entityListAndAdminHelper';

//TODO: it will be neccessary to implement on common files to avoid code duplication(see getAdminViews and dependence files)
export function getDashBoardViewsValues(orgChart, entities, isProjectOwner, userGui) {

	let hasExternal = false,
		milestones = 0,
		eyccp = 0,
		gaudit = 0,
		pmanagement = 0,
		insights = 0,
		reporting = 0;

	const normalizeNodes = (node) =>
		node.map((entity) => {
			let newContacts = [...entity.contacts];
			if (entities.some(({entityId}) => entityId === entity.entityId)) {
				newContacts = [...entities.find(({entityId}) => entityId === entity.entityId)?.contacts];
			}
			const newNodes = entity?.nodes?.length > 0 ? normalizeNodes(entity.nodes) : [];
			return {...entity, contacts: newContacts, nodes: newNodes};
		});

	const newOrgChart = normalizeNodes(orgChart);

	const filteredEntities = isProjectOwner
		? getAvailableEntityList(newOrgChart)
		: getAdminAvailableEntityList(newOrgChart, userGui);

	const getDashboardViewObject = () =>
		Object.values(dashboardTabId).map((id) => {
			let disabled = false,
				checked = false,
				indeterminate = false;

			const {key: label, tooltipText: tooltip, value: key} = currentResource?.dashboardContactViews.find(
			(x) => x.id === id
		);
			if (!isProjectOwner) {
				const adminViews = getAdminViews(filteredEntities, userGui);
				if (!(adminViews.includes(key) || adminViews.includes(dashboardViews.all))) disabled = true;
			}

			if (key === dashboardViews.milestones) {
				if (milestones !== 0) {
					checked = true;
					if (selected.length > milestones) indeterminate = true;
				}
			}

			if (key === dashboardViews.ccp) {
				if (eyccp !== 0) {
					checked = true;
					if (selected.length > eyccp) indeterminate = true;
				}
			}

			if (key === dashboardViews.groupAudit) {
				if (gaudit !== 0) {
					checked = true;
					if (selected.length > gaudit) indeterminate = true;
				}
			}

			if (key === dashboardViews.projectManagement) {
				if (pmanagement !== 0) {
					checked = true;
					if (selected.length > pmanagement) indeterminate = true;
				}
				if (hasExternal) disabled = true;
			}

			if (key === dashboardViews.insights) {
				if (insights !== 0) {
					checked = true;
					if (selected.length > insights) indeterminate = true;
				}
				if (hasExternal) disabled = true;
			}

			if (key === dashboardViews.reporting) {
				if (reporting !== 0) {
					checked = true;
					if (selected.length > reporting) indeterminate = true;
				}
			}

			return {id, label, tooltip, key, disabled, checked, indeterminate};
		});

	return {
		[DASHBOARD_VIEWS]: getDashboardViewObject()
	};
}